import { render, staticRenderFns } from "./gameplay-players-time-on-device.vue?vue&type=template&id=2a993c48&scoped=true&"
import script from "./gameplay-players-time-on-device.vue?vue&type=script&lang=js&"
export * from "./gameplay-players-time-on-device.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a993c48",
  null
  
)

export default component.exports